import React, { useState } from 'react';

import { Button } from './MoreButtonStyles';

export default function MoreButton({ openText, closeText, handleClick }) {
  const [isOpened, setOpenedStatus] = useState(false);

  const arrowToBottom = (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.91919 0.381683C1.30971 -0.00884148 1.94288 -0.00884166 2.3334 0.381683L6.97546 5.02374L11.6175 0.381682C12.008 -0.00884187 12.6412 -0.0088416 13.0317 0.381683L13.2684 0.618303C13.6589 1.00883 13.6589 1.64199 13.2684 2.03252L6.97546 8.32541L0.68257 2.03252C0.292046 1.64199 0.292047 1.00883 0.68257 0.618302L0.91919 0.381683Z"
        fill="#478CC8"
      />
    </svg>
  );

  const arrowToTop = (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0316 8.6183C12.6411 9.00883 12.0079 9.00883 11.6174 8.6183L6.97534 3.97624L2.33328 8.6183C1.94276 9.00883 1.30959 9.00883 0.919068 8.6183L0.682448 8.38168C0.291924 7.99116 0.291924 7.35799 0.682449 6.96747L6.97534 0.674576L13.2682 6.96747C13.6588 7.35799 13.6588 7.99116 13.2682 8.38168L13.0316 8.6183Z"
        fill="#478CC8"
      />
    </svg>
  );

  return (
    <Button
      onClick={() => {
        setOpenedStatus(!isOpened);
        handleClick();
      }}
    >
      <div>{isOpened ? closeText : openText}</div>
      <div className="icon">{isOpened ? arrowToTop : arrowToBottom}</div>
    </Button>
  );
}
